import { project02Images } from './assets';

const comparisonContent = [
  {
    id: 'comparison-01',
    title: 'Общий разрез объекта',
    description:
      'Сопоставление облака точек и BIM-модели показывает взаимное положение конструкций, оборудования и технологических элементов по высоте.',
  },
  {
    id: 'comparison-02',
    title: 'Технологическая зона',
    description:
      'Плотно расположенные конструкции, оборудование и трубопроводы восстановлены с сохранением их фактического пространственного положения.',
  },
  {
    id: 'comparison-03',
    title: 'Площадки и вертикальные связи',
    description:
      'В модели зафиксированы рабочие уровни, лестницы, ограждения и связанные с ними конструктивные элементы.',
  },
  {
    id: 'comparison-04',
    title: 'Детализация существующей компоновки',
    description:
      'Фрагмент показывает передачу сложного взаимного расположения конструкций и оборудования из облака точек в BIM-модель.',
  },
];

const comparisonItems = comparisonContent.map((item, index) => ({
  ...item,
  source: project02Images.comparisons[index].source,
  result: project02Images.comparisons[index].result,
}));

const resultContent = [
  ['result-01', 'Общий внешний вид', 'Наружный контур объекта и общая пространственная организация BIM-модели.'],
  ['result-02', 'Внутренняя компоновка', 'Несущие конструкции, рабочие уровни и технологическое оборудование внутри объекта.'],
  ['result-03', 'Конструкции и оборудование', 'Взаимное расположение колонн, площадок, лестниц, ёмкостей и технологических элементов.'],
  ['result-04', 'Наружный контур', 'Криволинейные наружные стены и вертикальные конструктивные элементы объекта.'],
  ['result-05', 'Технологическое оборудование', 'Основные ёмкости, агрегаты и элементы технологической системы, включённые в BIM-модель.'],
];

const resultItems = resultContent.map(([id, title, description], index) => ({
  id,
  title,
  description,
  ...project02Images.results[index],
}));

const project02 = {
  id: '2',
  slug: 'project-02',
  template: 'project-01',
  images: {
    catalog: project02Images.catalog,
    hero: project02Images.hero,
  },
  type: { id: 'bim-modeling', label: '3D BIM-модель' },
  catalog: {
    index: '02',
    title: '3D BIM-модель промышленного объекта',
    description:
      'As-Built BIM-модель промышленного объекта по данным лазерного сканирования. Модель подготовлена для дальнейшего проектирования и модернизации.',
    tags: ['3D BIM', 'Revit', 'As-Built'],
    skills: '3D BIM-модель, Scan-to-BIM, As-Built',
    image: project02Images.catalog,
    ctaLabel: 'Смотреть кейс',
  },
  hero: {
    backLabel: 'Назад к проектам',
    title: '3D BIM-модель промышленного объекта по облаку точек',
    titleLines: ['3D BIM-модель промышленного объекта', 'по облаку точек'],
    description:
      'As-Built BIM-модель существующего промышленного объекта, созданная по данным лазерного сканирования для дальнейшего проектирования и модернизации.',
    descriptionLines: [
      'As-Built BIM-модель существующего промышленного объекта, созданная по данным',
      'лазерного сканирования для дальнейшего проектирования и модернизации.',
    ],
    image: project02Images.hero,
    stats: [
      { id: 'area', value: 'As-Built BIM', label: 'Тип модели' },
      { id: 'format', value: 'RCP Point Cloud', label: 'Исходные данные' },
      { id: 'duration', value: 'RVT', label: 'Формат результата' },
    ],
  },
  visual: project02Images.hero,
  info: {
    equalHeight: true,
    items: [
      { id: 'client', label: 'Заказчик', value: 'Инженерно-проектная компания' },
      { id: 'stage', label: 'Этап', value: 'Подготовка к модернизации' },
      { id: 'workPurpose', label: 'Назначение работ', value: 'As-Built BIM-моделирование' },
      { id: 'year', label: 'Тип объекта', value: 'Промышленный объект' },
    ],
  },
  introAccordion: {
    aboutHint: 'Контекст, выполненные работы и результат',
    sourceDataTitle: 'Исходные данные и требования',
    sourceDataHint: 'Формат облака, охват и требования к 3D BIM-модели',
    tasksHint: 'Основные задачи при подготовке 3D BIM-модели',
    processHint: 'Этапы подготовки и выдачи 3D BIM-модели',
  },
  about: {
    title: 'О проекте',
    bodyOnly: true,
    paragraphs: [
      'Объект представляет собой существующее промышленное сооружение с круглым наружным контуром и насыщенной внутренней компоновкой. Внутри размещены несущие конструкции, рабочие площадки, лестницы, технологические ёмкости, оборудование и трубопроводы.',
      'На основе зарегистрированного облака точек была создана As-Built 3D BIM-модель, передающая фактическую геометрию объекта и взаимное расположение его основных конструктивных и технологических элементов.',
      'Итоговая модель сформировала единую цифровую основу существующего состояния объекта для дальнейшего анализа, координации и разработки решений по модернизации.',
    ],
  },
  sourceData: {
    title: 'Исходные данные',
    items: [
      { id: 'format', label: 'Формат облака точек', value: 'RCP' },
      { id: 'additionalMaterials', label: 'Дополнительные материалы', value: 'Сопроводительные материалы по объекту' },
      { id: 'coverage', label: 'Охват', value: 'Наружный контур и внутреннее технологическое пространство' },
      { id: 'result', label: 'Требуемый результат', value: 'As-Built 3D BIM Model' },
    ],
    capturedTitle: 'Что было зафиксировано',
    capturedItems: [
      { id: 'structure', label: 'Несущие колонны, стены и перекрытия' },
      { id: 'ceiling', label: 'Рабочие площадки, лестницы и ограждения' },
      { id: 'roof', label: 'Основное технологическое оборудование и ёмкости' },
      { id: 'facades', label: 'Крупные трубопроводы и видимые инженерные элементы' },
      { id: 'equipment', label: 'Фактическое взаимное расположение элементов внутри объекта' },
    ],
  },
  tasks: {
    title: 'Задача проекта',
    items: [
      'Преобразовать зарегистрированное облако точек в структурированную As-Built 3D BIM-модель.',
      'Воссоздать фактическую геометрию основных конструкций с учётом существующих отклонений.',
      'Смоделировать рабочие площадки, лестницы, технологические ёмкости, оборудование и основные видимые инженерные элементы.',
      'Сохранить фактическое взаимное расположение конструкций и оборудования в условиях плотной внутренней компоновки.',
      'Подготовить модель для дальнейшего проектирования, координации и разработки решений по модернизации.',
    ],
  },
  process: {
    title: 'Процесс работы',
    items: [
      {
        id: '01',
        title: 'Подготовка исходных данных',
        text: 'Проверили облако точек, пространственную ориентацию объекта и доступность геометрии в ключевых зонах моделирования.',
      },
      {
        id: '02',
        title: 'Создание 3D BIM-модели',
        text: 'Последовательно воссоздали несущие конструкции, рабочие площадки, лестницы, оборудование, ёмкости и основные инженерные элементы по фактической геометрии облака точек.',
      },
      {
        id: '03',
        title: 'Контроль и выдача',
        text: 'Сопоставили BIM-модель с облаком точек, проверили положение основных элементов и подготовили итоговую модель к передаче.',
      },
    ],
  },
  comparisonGallery: {
    title: 'Point Cloud to 3D BIM Model',
    description:
      'Четыре сопоставления показывают, как фактическая геометрия отдельных зон промышленного объекта была восстановлена из облака точек в структурированной 3D BIM-модели.',
    sourceLabel: 'Point Cloud',
    resultLabel: '3D BIM Model',
    modalLabel: 'Просмотр Point Cloud to 3D BIM Model',
    items: comparisonItems,
  },
  resultGallery: {
    title: 'Итоговая 3D BIM-модель',
    mobileTitleLines: ['Итоговая 3D BIM-', 'модель'],
    description:
      'Модель отражает существующую конфигурацию конструкций, технологического оборудования и основных инженерных элементов промышленного объекта и может использоваться как исходная база для последующей модернизации.',
    modalLabel: 'Просмотр итоговой 3D BIM-модели',
    modalEnabled: true,
    zoomEnabled: true,
    addGridSpacing: true,
    carouselEnabled: true,
    items: resultItems,
  },
  deliverables: {
    title: 'Что получил клиент',
    items: [
      'As-Built 3D BIM-модель существующего промышленного объекта',
      'Зафиксированную пространственную компоновку оборудования, площадок и инженерных элементов',
      'Цифровую основу для дальнейшего проектирования и координации',
    ],
  },
  benefits: {
    title: 'Что это дало',
    items: [
      'Возможность работать с существующим объектом в единой пространственной модели',
      'Более наглядное понимание взаимного расположения конструкций и оборудования',
      'Исходную BIM-базу для подготовки последующих проектных решений',
    ],
  },
  metrics: {
    title: 'Параметры проекта',
    equalHeight: true,
    items: [
      { id: 'area', label: 'Площадь здания', value: '475 м²' },
      { id: 'volume', label: 'Объём данных (облако точек)', value: '3.10 ГБ' },
      { id: 'timeline', label: 'Время моделирования', value: '1 мес.' },
      { id: 'format', label: 'Формат', value: 'RVT' },
    ],
  },
  estimateCta: {
    eyebrow: 'Оценка по вашим данным',
    title: ['Нужно превратить облако точек', 'в рабочую 3D BIM-модель?'],
    text: 'Пришлите фрагмент облака точек или техническое задание. Мы оценим состав и уровень детализации модели, сроки выполнения и подготовим предложение по проекту.',
    buttonLabel: 'Получить оценку проекта',
    href: '/contacts',
    image: project02Images.catalog,
  },
  seo: {
    title: '3D BIM-модель промышленного объекта по облаку точек | DotPolyline',
    description:
      'As-Built BIM-модель существующего промышленного объекта, созданная по данным лазерного сканирования для дальнейшего проектирования и модернизации.',
  },
};

export default project02;
